function normalizeHeaderValue(value, index) {
  const normalized = String(value ?? '').trim()
  return normalized || `Column ${index + 1}`
}

function makeUniqueHeaders(values, { reserved = [] } = {}) {
  const seen = new Map()
  reserved.forEach((value) => {
    if (value) {
      seen.set(value, 1)
    }
  })

  return values.map((value, index) => {
    const base = normalizeHeaderValue(value, index)
    const nextCount = (seen.get(base) || 0) + 1
    seen.set(base, nextCount)

    return nextCount === 1 ? base : `${base} (${nextCount})`
  })
}

export function transposeDataset(dataset = []) {
  if (!Array.isArray(dataset) || dataset.length === 0) {
    return []
  }

  const sourceHeaders = Object.keys(dataset[0] || {})
  if (sourceHeaders.length === 0) {
    return []
  }

  const matrix = [
    sourceHeaders,
    ...dataset.map((row) => sourceHeaders.map((header) => row?.[header] ?? '')),
  ]

  const transposedMatrix = matrix[0].map((_, columnIndex) =>
    matrix.map((row) => row[columnIndex] ?? '')
  )

  const firstColumnHeader = normalizeHeaderValue(transposedMatrix[0][0], 0)
  const derivedHeaders = transposedMatrix[0].slice(1).map((value, index) => {
    const normalized = String(value ?? '').trim()
    return normalized || `Row ${index + 1}`
  })
  const nextHeaders = [
    firstColumnHeader,
    ...makeUniqueHeaders(derivedHeaders, { reserved: [firstColumnHeader] }).map(
      (header, index) => (/\(\d+\)$/.test(header) ? `Row ${index + 1}` : header)
    ),
  ]

  return transposedMatrix.slice(1).map((row) =>
    Object.fromEntries(
      nextHeaders.map((header, index) => [header, row[index] ?? ''])
    )
  )
}
